/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WorkflowMetaCode {
    NAME = 'Name',
    ARCHIVED_AT = 'ArchivedAt',
    UPDATED_AT = 'UpdatedAt',
    STATUS = 'Status',
    FOR = 'For',
}
